import { render } from "./Developpeur.vue?vue&type=template&id=68ecc40b&scoped=true"
import script from "./Developpeur.vue?vue&type=script&lang=js"
export * from "./Developpeur.vue?vue&type=script&lang=js"

import "./Developpeur.vue?vue&type=style&index=0&id=68ecc40b&lang=scss&scoped=true"

import exportComponent from "/home/maud/code/ixperya2.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68ecc40b"]])

export default __exports__